import React, { Component } from 'react'
import Tappable from 'react-tappable'

import classNames from './Thumbnail.css'
import Icon from '../Icon'

const PRESS_DELAY = 500

export default class Thumbnail extends Component {
  state = {
    loaded: false
  }
  componentDidMount () {
    const { src } = this.props
    this.img = new window.Image()
    this.img.onload = () => this.setState({ loaded: true })
    this.img.src = src
  }
  componentWillUnmount () {
    this.img.src = ''
  }
  render () {
    const { id, src, onClick, onPress, selected, size, showInfoLink, selectImageMode, onClickInfo } = this.props
    const { loaded } = this.state
    const imageClassName = loaded ? classNames.imageLoaded : classNames.image
    return (
      <li className={classNames.thumbnail} style={{ maxWidth: `${size}px` }}>
        <Tappable onTap={onClick} onPress={onPress} pressDelay={PRESS_DELAY}>
          <Image id={id} className={imageClassName} style={{ backgroundImage: `url(${src})` }} size={size} />
        </Tappable>
        {showInfoLink && loaded && !selectImageMode &&
          <button onClick={onClickInfo} className={classNames.infoLink}>
            i
          </button>
        }
        {selectImageMode &&
          <div className={selected ? classNames.selectedOverlayActive : classNames.selectedOverlay} />
        }
      </li>
    )
  }
}

class Image extends Component {
  shouldComponentUpdate (nextProps) {
    return this.props.id !== nextProps.id ||
      this.props.className !== nextProps.className ||
      this.props.size !== nextProps.size
  }
  render () {
    return <div {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/gallery/Thumbnail.js